
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { CoreService } from 'src/app/services/core.service';

@Component({
    selector: 'app-branding',
    imports: [RouterLink],
    template: `
  <div class="p-r-0 p-l-20 p-y-12 overflow-hidden">
    <a [routerLink]="['/']" (click)="logout()" class="brand">
      <img [src]="'./assets/images/logos/tranrevisjon.png'"
           [height]="options.sidenavCollapsed ? 40 : 50"
           class="align-middle m-l-2"
           alt="logo"/>
      <div>Tinglysninger</div>
      @if(options.sidenavCollapsed && !smallScreen && isHovering) {
        <img [src]="'./assets/images/logos/logo-text.svg'"
             [height]="34"
             class="m-l-8 m-t-4"
             alt="logo"/>
      }
    </a>
  </div>
`,
    styleUrls: ['./branding.component.scss']
})
export class BrandingComponent {
  @Input() smallScreen = false;
  @Input() isHovering: boolean;
  options = this.settings.getOptions();
  
  constructor(
    private settings: CoreService,
    private authService: AuthService
  ) { }

  logout() {
    this.authService.signOut();
  }
}
